<template>
  <div id="administrador">
    <!-- <div class="separador text-center mt-5 py-5" data-aos="fade-up" data-aos-delay="600">
      <p class="otrafont fXG electrico">Cuestionarios Registrados</p>
    </div> -->

    <HeaderAdmin></HeaderAdmin>

    <div class="pt4">
      <!-- <div class="row pb-5">
        <div class="col-12 otrafont fpR electrico">Semana 1</div>
      </div>-->

      <!-- <b-sidebar id="sidebar-1" title="Menú" shadow>
        <div class="px-3 py-2">
          <a class="float-right fpR pointer" @click="logout"> Cerrar Sesión </a>
        </div>
      </b-sidebar> -->

      <div class="row m-0">
        <div class="col-3">
          <div class="row">
            <div class="col-12">
              <SidebarAdmin></SidebarAdmin>
            </div>
          </div>
        </div>

        <div class="col-9 bgazuladmin bgazulgradiente p-5">
          <div class="row p-3" data-aos="fade-left" data-aos-delay="200">
            <form action="" class="formadmin blanco fpXG2">
              <label>
                <span>Usuario Administrador</span>
                <input type="text" v-model="userProfile.email" readonly />
              </label>
            </form>
          </div>

          <div class="row p-3" data-aos="fade-left" data-aos-delay="200">
            <form
              action=""
              class="formadmin blanco fpXG2"
              @submit="submitForm($event)"
            >
              <label>
                <span>Cargar Logo</span>
                <button
                  type="button"
                  @click="$refs.file.click()"
                  v-if="this.file == null"
                >
                  Elegir imagen
                </button>
                <button type="submit" v-if="this.file != null">Subir</button>
                <div id="preview" v-if="this.file != null"></div>
              </label>

              <input
                type="file"
                class="hidden"
                ref="file"
                @change="fileSelected"
              />
            </form>
          </div>

          

          <div class="row p-3" data-aos="fade-left" data-aos-delay="200">
            <form action="" class="formadmin blanco fpXG2">
              <label>
                <span>Cambiar contraseña</span>
                <button type="button" @click="cambiarContrasena()">
                  Cambiar contraseña
                </button>
              </label>
            </form>
          </div>


          <div class="row p-3" data-aos="fade-left" data-aos-delay="200" v-if="userProfile.institucion == '' || userProfile.institucion == undefined">
            <form action="" class="formadmin blanco fpXG2">
              <label class="d-flex flex-column flex-md-row">
                <span class="d-flex flex-column w-50 pb-5">
                  <span class="w-100">ID E-commerce: </span>
                  <span class="small w-100 pr-5">(Comparte este ID con tus alumnos para comprar por medio del E-commerce)</span>
                </span>
                <span class="w-75">
                  {{institucionID}}
                </span>
              </label>
            </form>
          </div>


        </div>
      </div>
    </div>

    <Glyphicons></Glyphicons>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SidebarAdmin from "@/components/SidebarAdmin";
import HeaderAdmin from "@/components/HeaderAdmin";

import * as fb from "../../firebase";
import * as moment from "moment";
import { misionesCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    SidebarAdmin,
    HeaderAdmin,
    Glyphicons,
  },
  data() {
    return {
      file: null,
      form: {
        nombre_administrador: "",
        email: "",
        password: "",
        password2: "",
      },
      initiated: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.init();
  },
  methods: {
    init() {
      console.log("userProfile -->", this.userProfile)
      if (this.userProfile == null || this.initiated == true) {
        return;
      }

      console.log("iniciando admin");

      this.initiated = true;

      /////////////
      this.camposObj = this.$store.state.campos_conocimiento;
    },
    fileSelected: function ($event) {
      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    async submitForm(e) {
      e.preventDefault();
      this.$store.dispatch("showLoader", true);

      let institucion = {
        institucion_id: this.institucionID,
        ecommerce_user_id: this.userProfile.ecommerce_user_id,
        nombre: this.userProfile.nombre,
        logo: this.file,
      };

      await this.$store.dispatch("setLogoAdministrador", {
        institucion: institucion,
      });

      this.file = null;
      this.$store.dispatch("showLoader", false);

      window.location.reload();
    },
    cambiarContrasena() {
      this.$store.dispatch("resetContrasena");
    },
    logout() {
      this.$store.dispatch("logoutReportes");
    },
  },
};
</script>
